// eslint-disable-next-line import/no-unresolved
import { SchemaModifier } from '../types';
import { generateExecutions } from '../utils';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

const EVENT_TYPE: Record<string, string> = {
  info_event_degree_programmes: 'EducationEvent',
  info_event_continuing_education: 'EducationEvent',
  concert: 'MusicEvent',
  exhibition_presentation: 'ExhibitionEvent',
  workshop_seminar: 'EducationEvent',
  lecture_series: 'LiteraryEvent',
  conference_congress: 'ConferenceEvent',
};

const eventSeriesModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.organized_by) {
    main['organizer'] = content.organized_by;
  }
  const event_type = normalizeContent(content?.event_type) as string;
  if (event_type && EVENT_TYPE?.[event_type]) {
    main['eventType'] = EVENT_TYPE[event_type];
  }
  if (content?.occasions) {
    main['subEvents'] = generateExecutions(
      content.occasions,
      content,
      'Event',
      state,
    );
  }
};

export default eventSeriesModifier;
